import {apiRequest} from '../api/client';
import {getLocalVideo} from '../local-video-library';

async function finalFrame(blob:Blob):Promise<Blob>{
  const video=document.createElement('video');video.muted=true;video.playsInline=true;
  const url=URL.createObjectURL(blob);video.src=url;
  try{return await new Promise<Blob>((resolve,reject)=>{
    const timer=setTimeout(()=>fail(),15000);
    const fail=()=>{clearTimeout(timer);reject(new Error('Не удалось прочитать финальный кадр на этом устройстве. Попробуйте другое видео.'))};
    video.onerror=fail;
    const capture=()=>{const canvas=document.createElement('canvas');canvas.width=video.videoWidth;canvas.height=video.videoHeight;const context=canvas.getContext('2d');if(!context||!canvas.width||!canvas.height){fail();return}try{context.drawImage(video,0,0);canvas.toBlob(result=>{clearTimeout(timer);if(result)resolve(result);else fail()},'image/jpeg',0.9)}catch{fail()}};
    video.onloadeddata=()=>{if(!Number.isFinite(video.duration)||video.duration<=0){fail();return}video.onseeked=capture;video.currentTime=Math.max(0,video.duration-0.05);if(video.currentTime===0)capture()};
    video.load();
  })}finally{video.removeAttribute('src');video.load();URL.revokeObjectURL(url)}
}
export async function localVideoReference(jobId:string,kind:'video'|'final_frame'){
  const stored=await getLocalVideo(jobId);
  if(!stored)throw new Error('Локальный файл не найден. Добавьте его заново с телефона.');
  const blob=kind==='video'?stored.video:await finalFrame(stored.video);
  const body=new FormData();body.append('file',blob,kind==='video'?`vgen-${jobId}.mp4`:`vgen-${jobId}-final.jpg`);
  const result=await apiRequest<{media:{id:string;originalName:string}}>('/api/media?temporary=true',{method:'POST',body});
  return{mediaId:result.media.id,mediaName:kind==='video'?'Видео':'Финальный кадр',mediaKind:kind==='video'?'source_video':'source_image',temporary:true};
}
